"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endash = exports.Display = exports.Serif = exports.Sans = exports.BaseText = exports.renderFontValue = void 0;

var _react = _interopRequireDefault(require("react"));

var _primitives = require("../../platform/primitives");

var _Theme = require("../../Theme");

var _styledSystem = require("styled-system");

var _isReactNative = require("../../helpers/isReactNative");

var _determineFontSizes = require("./determineFontSizes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Spec: https://www.notion.so/artsy/Typography-d1f9f6731f3d47c78003d6d016c30221
 */

/** renderFontValue */
var renderFontValue = function renderFontValue(fontValue) {
  if (typeof fontValue === "string") {
    return "font-family: ".concat(fontValue);
  } else {
    return ["font-family: ".concat(fontValue.fontFamily)].concat(fontValue.fontStyle ? "font-style: ".concat(fontValue.fontStyle) : []).concat(fontValue.fontWeight ? "font-weight: ".concat(fontValue.fontWeight) : []).join(";\n");
  }
};

exports.renderFontValue = renderFontValue;

/** Base Text component for typography */
var BaseText = _primitives.styled.Text(_templateObject(), function (_ref) {
  var fontFamily = _ref.fontFamily;
  return fontFamily && renderFontValue(fontFamily);
}, _styledSystem.fontSize, _styledSystem.lineHeight, _styledSystem.color, _styledSystem.display, _styledSystem.maxWidth, _styledSystem.space, _styledSystem.textAlign, _styledSystem.verticalAlign);
/**
 * The supported typefaces
 */


exports.BaseText = BaseText;

/**
 * Returns the weight, if given, otherwise it defaults to `regular` unless
 * explicitly given `null` in which case it returns undefined, meaning the
 * weight should be inherited from the component’s parent.
 *
 * @param weight
 */
function _fontWeight(weight) {
  if (weight === null) {
    return undefined;
  }

  return weight || "regular";
}

function _selectFontFamilyType(weight, italic) {
  return italic ? "italic" : weight;
}

/**
 * Creates a wrapper around the generic `Text` component for a font type defined
 * in the palette’s theme (sans, serif, or display).
 *
 * The component’s props are specified with type parameter `P` and should hold
 * both the component’s specific props (size, weight, italic) as well as all of
 * the generic `Text` component’s props, although as optional.
 *
 * @param fontType
 *        The font type that this text component represents.
 * @param selectFontFamilyType
 *        An optional function that maps weight+italic to a font-family.
 */
function createStyledText(fontType) {
  var selectFontFamilyType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _selectFontFamilyType;
  return (0, _primitives.styledWrapper)(function (_ref2) {
    var size = _ref2.size,
        weight = _ref2.weight,
        italic = _ref2.italic,
        _style = _ref2.style,
        unstable_trackIn = _ref2.unstable_trackIn,
        element = _ref2.element,
        textProps = _objectWithoutProperties(_ref2, ["size", "weight", "italic", "style", "unstable_trackIn", "element"]);

    var fontFamilyType = selectFontFamilyType(_fontWeight(weight), italic); // This is mostly to narrow the type of `fontFamilyType` to remove `null`.

    if (fontFamilyType === null) {
      throw new Error("Did not expect `fontType` to be `null`.");
    }

    return _react.default.createElement(BaseText, _extends({
      fontFamily: fontFamilyType && _Theme.themeProps.fontFamily[fontType][fontFamilyType],
      style: (0, _isReactNative.isReactNative)() ? _style : _objectSpread({}, unstable_trackIn ? {
        letterSpacing: "-0.03em"
      } : {}, _style)
    }, (0, _determineFontSizes.determineFontSizes)(fontType, size), element ? {
      as: element
    } : {}, textProps));
  })(_templateObject2());
}
/**
 * Sans
 */


/**
 * The Sans typeface is used for presenting objective dense information
 * (such as tables) and intervening communications (such as error feedback).
 *
 * @example
 *
 * <Sans color="black10" size="3t" weight="medium" italic>Hi</Sans>
 */
var Sans = createStyledText("sans", function (weight, italic) {
  return italic && weight === "medium" ? "mediumItalic" : _selectFontFamilyType(weight, italic);
});
/**
 * Serif
 */

exports.Sans = Sans;

/**
 * The Serif typeface is used as the primary Artsy voice, guiding users through
 * flows, instruction, and communications.
 *
 * @example
 *
 * <Serif color="black10" size="3t" weight="semibold">Hi</Serif>
 */
var Serif = createStyledText("serif", function (weight, italic) {
  if (italic && weight && weight !== "regular") {
    throw new Error("The serif font does not have an italic font with weight `".concat(weight, "`"));
  }

  return _selectFontFamilyType(weight, italic);
});
exports.Serif = Serif;

/**
 * The Display typeface has limited utility and is in the process of being
 * phased out in most places. Ask your friendly neighborhood design team member
 * if you're unsure if it should be used.
 *
 * @example
 *
 * <Display color="black10" size="3t">Hi</Display>
 */
var Display = createStyledText("display");
exports.Display = Display;
Sans.displayName = "Sans";
Serif.displayName = "Serif";
Display.displayName = "Display";
/**
 * The endash is used in ranges like `$10k – $20k`.
 * This export makes it easier to use in the code, without having to find
 * the character in unicode.
 * It is a different character to the regular minus, usually a bit longer.
 * (for reference: minus `-`, endash `–`)
 */

var endash = "–";
exports.endash = endash;
//# sourceMappingURL=Typography.js.map